enum AddRemoveTagsAction {
  None = "None",
  AddTags = "AddTags",
  RemoveTags = "RemoveTags",
}

export default AddRemoveTagsAction;
